import { shape, oneOf } from 'prop-types';
import styled from 'styled-components';
import { DateTime } from 'luxon';
import { ReactComponent as ErrorSvg } from '../../../assets/icons/circle-exclamation-solid.svg'
import Button from '../../StoraEnsoComponents/Button';
import ConfirmationModal from '../../ConfirmationModal';
import NotificationToast from '../../NotificationToast';
import { useState } from 'react';
import { deleteProject } from '../../../services/projectService';
import { useNavigate } from 'react-router-dom';
import { DRONE_MAP } from '../../../Routes';

const ErrorIcon = styled(ErrorSvg)`
    width: 30px;
    height: auto;
    fill: ${({theme}) => theme.colors.bg_gray_dark};
    margin-bottom: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2rem;
  column-gap: 2rem;
  position: relative;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

`;

const DeleteButton = styled(Button)`
    margin: auto;
    display: flex;
    margin-top: 5pt;`;

const InfoWrapper = styled(Grid)`
  grid-template-columns: 1fr;
  column-gap: 1rem;
`;

const MapWrapper = styled.div`
`;

const Table = styled.table`
  border-collapse: collapse;

  tr td {
    padding: 0.25rem 1rem;
    vertical-align: top;
    border-bottom: 1px solid ${({ theme }) => theme.colors.bg_gray};
  }

  tr td:first-child {
    font-weight: bold;
    padding-right: 1.5rem;
  }

  ul {
    list-style-type: square;
  }
`;

const MissingMapData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${({theme}) => theme.colors.bg_gray_light};
`;

const ActionsWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.bg_gray_light};
  padding: 1rem;
  margin: 1rem 0;
`;


function BasicDroneInformation({data}) {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [actionResult, setActionResult] = useState(null);

  const handleDeleteProject = () => {
    deleteProject(data.id).then(navigate(DRONE_MAP))
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'An error has occurred while changing project status!'
        });
      });
  }

    return (
      <>
      <Grid>
        <InfoWrapper id="informationTable">
          <Table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{data.name}</td>
              </tr>
              <tr>
                <td>ID</td>
                <td>{data.id}</td>
              </tr>
              <tr>
                <td>Description</td>
                <td>{data.description}</td>
              </tr>
              <tr>
                <td>Location - EPSG</td>
                <td>{data.location_name} - {data.epsg}</td>
              </tr>
              <tr>
                <td>Pilot</td>
                <td>{data.pilot}</td>
              </tr>
            </tbody>
          </Table>
        </InfoWrapper>
        <InfoWrapper >
          <Table>
            <tbody>
            <tr>
                <td>Mission Type</td>
                <td>{data.location_type}</td>
              </tr>
              <tr>
                <td>Created</td>
                <td>{!data.cd ? '-' : DateTime.fromISO(data.cd).toLocaleString({dateStyle: 'long'})}</td>
              </tr>
              <tr>
                <td>Captured</td>
                <td>{!data.datetime ? '-' : DateTime.fromISO(data.datetime).toLocaleString({dateStyle: 'long'})}</td>
              </tr>
              <tr>
                <td>Drone Camera</td>
                <td>{data.device}</td>
              </tr>
              <tr>
                <td>Uploaded images</td>
                <td>{data.img_count}</td>
              </tr>
            </tbody>
          </Table>
        </InfoWrapper>
        <NotificationToast
          toastId="deleteProject"
          kind={actionResult?.kind}
          message={actionResult?.message}
          onClose={() => setActionResult(null)}
        />
        <ConfirmationModal
          isOpen={isModalOpen}
          kind="error"
          title="Project Delete"
          okBtnLabel="Confirm"
          onClose={() => setModalOpen(false)}
          onSubmit={() => {
          handleDeleteProject();
          setModalOpen(false);
        }}
        >
          Do you really want to DELETE this project? This action can not be reversed.
        </ConfirmationModal>
      </Grid>
      <DeleteButton onClick={()=>{setModalOpen(true)}}>Delete Project</DeleteButton>
      </>
    );

}

BasicDroneInformation.propTypes = {
  data: shape({}).isRequired
}

export default BasicDroneInformation;